export default "__VITE_ASSET__FWwL_sJ6__"